import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { MerchantProfile } from '@/types'

const TOKEN_KEY = 'piv9_merchant_token'
const PROFILE_KEY = 'piv9_merchant_profile'
const EXPIRES_KEY = 'piv9_merchant_expires'

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(localStorage.getItem(TOKEN_KEY))
  const expiresAt = ref<string | null>(localStorage.getItem(EXPIRES_KEY))
  const profile = ref<MerchantProfile | null>(
    (() => {
      const raw = localStorage.getItem(PROFILE_KEY)
      return raw ? (JSON.parse(raw) as MerchantProfile) : null
    })()
  )

  const isAuthenticated = computed(() => {
    if (!token.value) return false
    if (expiresAt.value && new Date(expiresAt.value).getTime() < Date.now()) return false
    return true
  })

  function setSession(newToken: string, newProfile: MerchantProfile, newExpiresAt: string) {
    token.value = newToken
    profile.value = newProfile
    expiresAt.value = newExpiresAt
    localStorage.setItem(TOKEN_KEY, newToken)
    localStorage.setItem(PROFILE_KEY, JSON.stringify(newProfile))
    localStorage.setItem(EXPIRES_KEY, newExpiresAt)
  }

  function logout() {
    token.value = null
    profile.value = null
    expiresAt.value = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(PROFILE_KEY)
    localStorage.removeItem(EXPIRES_KEY)
  }

  return { token, profile, expiresAt, isAuthenticated, setSession, logout }
})
